<template>
    <div>
        <div v-if="!loggedIn" class="home">
            <Login />
        </div>
        <div class="w-full md:w-4/5 m-auto py-6 px-0 md:px-12">
            <div v-if="!loaded" class="lds-spinner">
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
            </div>
            <div v-if="loggedIn" class="bg-white text-left mb-1 p-8 border border-gray-300 rounded">
                <p class="mb-4 text-lshtm-primary text-2xl text-center">
                    Welcome to the London School of Hygiene & Tropical Medicine Application Portal
                </p>
                <div v-if="serverError" class="server-error mt-6">{{ serverError }}</div>
                <div class="flex flex-column w-full">
                    <div v-if="loaded" class="w-full justify-content-center align-content-center text-center">
                        <!-- fix required - dont display button if there is already an application in progress -->
                        <form
                            v-for="module in modules.filter(v => v.enabled === true)"
                            :key="module.id"
                            action="#"
                            @submit.prevent="create({ module: module.reference })"
                        >
                            <button
                                class="bg-lshtm-primary hover:bg-lshtm-primary text-white py-3 px-4 w-full font-bold rounded mt-4 mr-2 btn-submit"
                                :disabled="loading"
                            >
                                <div v-if="loading" class="lds-ring-container">
                                    <div class="lds-ring">
                                        <div />
                                        <div />
                                        <div />
                                        <div />
                                    </div>
                                </div>
                                Start {{ module.name }} application
                            </button>
                        </form>
                    </div>
                    <div class="w-full ">
                        <router-link v-if="applicationData.length !== 0" :to="{ name: 'ViewApplication' }">
                            <button class="bg-yellow-600 hover:bg-yellow-700 text-black py-3 px-4 w-full rounded mt-4">
                                Manage Your Applications
                            </button>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Login from '@/views/Auth/Login.vue'

export default {
  name: 'Home',
  components: {
    Login,
  },
  emits: ['getUser'],
  data() {
    return {
      applicationData: [],
      personalData: [],
      loading: false,
      loaded: false,
      serverError: '',
      loggedIn: false,
    }
  },
  computed: {
    applicationDetails() {
      return this.$store.getters.applicationDetails
    },
    modules() {
      return this.$store.getters.modules
    },
  },
  // wait for applicationsDetails to return data before rendering
  watch: {
    applicationDetails(data) {
      this.applicationData = data.data
      this.loaded = true
      if (data.data.length > 0) {
        this.$emit('getUser', data.data[0]['name'])
      }
    },
    modules(data) {
      this.modules = data
      this.loaded = true
    },
  },
  // redirect if not logged in / check if logged in user has an application
  mounted() {
    if (this.$store.getters.loggedIn) {
      this.loggedIn = true
      this.retrieveApplications()
      this.getModules()
    } else {
      this.$router.push({ name: 'Login' })
    }
  },
  methods: {
    create(data = {}) {
      this.loading = true
      this.$store
        .dispatch('createApplication', data)
        .then(() => {
          this.$router.push({ name: 'ViewApplication' })
          this.loading = false
        })
        .catch((error) => {
          this.serverError = error.response.data
          this.loading = false
        })
    },
    retrieveApplications() {
      this.$store
        .dispatch('retrieveApplications')
        .then(() => {})
        .catch(() => {})
    },
    getModules() {
      this.$store
        .dispatch('getModules')
        .then(() => {})
        .catch(() => {})
    },
  },
}
</script>